// --- BEGIN AUTO-GENERATED FILE ---
//
// This file is auto generated on each build. Do not edit this file!
// Run the necessary scripts defined in package.json to generate this file.

import Vue from "vue";

import {
  AnxIcon24h,
  AnxIcon3d,
  AnxIconLKWTransport,
  AnxIconAiKuenstlicheintelligenz,
  AnxIconAlexa,
  AnxIconAnderesWeiteresTeil,
  AnxIconAndroid,
  AnxIconAnexiaStamp,
  AnxIconAnexia,
  AnxIconApp,
  AnxIconApple,
  AnxIconArbeitBuero,
  AnxIconArrowGreenBottom,
  AnxIconArrowRedBottom,
  AnxIconAtSign,
  AnxIconAuszeichnung,
  AnxIconBarcode,
  AnxIconBildFoto,
  AnxIconBlockchain,
  AnxIconCardboardVrBrilleSmartphone,
  AnxIconCardboardVrBrille,
  AnxIconCheckGreen,
  AnxIconCheckWhite,
  AnxIconCheck,
  AnxIconCloudStorage,
  AnxIconCloud,
  AnxIconCloudservicesHosting,
  AnxIconConnections,
  AnxIconController,
  AnxIconCopy,
  AnxIconDashboardEchtzeitMonitor,
  AnxIconDatenbank,
  AnxIconDevices,
  AnxIconDns,
  AnxIconDokument,
  AnxIconDollar,
  AnxIconDownload,
  AnxIconDsl,
  AnxIconESim,
  AnxIconEingabe,
  AnxIconEins,
  AnxIconEinstellungenVerwaltung,
  AnxIconError,
  AnxIconEuro,
  AnxIconExperimentierfreudig,
  AnxIconFabrik,
  AnxIconFirmenautoAuto,
  AnxIconFlexibilitaet,
  AnxIconFlexibleArbeitszeitenTiming,
  AnxIconFolder,
  AnxIconForschungEntwicklung,
  AnxIconFotoapparat,
  AnxIconFramework,
  AnxIconGabelstapler,
  AnxIconGefahrenWarnung,
  AnxIconGenericautomation,
  AnxIconHerz,
  AnxIconHomeoffice,
  AnxIconIdee,
  AnxIconInformation,
  AnxIconInstallation,
  AnxIconInterdisziplinaer,
  AnxIconIp,
  AnxIconKalender,
  AnxIconKontaktTelefonTelekommunikation,
  AnxIconKonzept,
  AnxIconKunde,
  AnxIconKunden,
  AnxIconLaden,
  AnxIconLastverteilung,
  AnxIconLike,
  AnxIconLoeschen,
  AnxIconMailKontakt,
  AnxIconMassgeschneiderteIndividuelleLoesungen,
  AnxIconMbaas,
  AnxIconMicrocontroller,
  AnxIconMitarbeiterevents,
  AnxIconMobileEntwicklung,
  AnxIconMonitoring,
  AnxIconMusik,
  AnxIconNetzwerk,
  AnxIconOeffentlicherNahverkehr,
  AnxIconOffline,
  AnxIconOnlineshopWarenkorb,
  AnxIconPaket,
  AnxIconParkplatz,
  AnxIconPartyProjektabschluss,
  AnxIconPdf,
  AnxIconPfeilLinksKlein,
  AnxIconPfeilLinks,
  AnxIconPfeilOben,
  AnxIconPfeilRechtsKlein,
  AnxIconPfeilRechts,
  AnxIconPfeilRunter,
  AnxIconPflichtenheft,
  AnxIconPlatform,
  AnxIconPraesentation,
  AnxIconProjektablauf,
  AnxIconProjektmanagementCheckliste,
  AnxIconRedundant,
  AnxIconSatellit,
  AnxIconSchluessel,
  AnxIconScrum,
  AnxIconSeoSemCrawler,
  AnxIconServerVeerbunden,
  AnxIconServiceprovider,
  AnxIconSharing,
  AnxIconShop,
  AnxIconSicherheitFirewall,
  AnxIconSignal,
  AnxIconSkalierbar,
  AnxIconSmartTv,
  AnxIconSmartWatch,
  AnxIconSmarthome,
  AnxIconSoftwareentwicklungCode,
  AnxIconSpieleUndSpass,
  AnxIconSprechblasen,
  AnxIconStandortUnternehmenssitz,
  AnxIconStartUp,
  AnxIconStatistikAnalysen,
  AnxIconStern,
  AnxIconStorageBackup,
  AnxIconStromEnergie,
  AnxIconSuchen,
  AnxIconSupportMitarbeiter,
  AnxIconTasse,
  AnxIconTeam,
  AnxIconTechnischerSupport,
  AnxIconTextdokument,
  AnxIconTextdokumentFragezeichen,
  AnxIconTextdokumentRufzeichen,
  AnxIconUpload,
  AnxIconUserProfil,
  AnxIconVerbundeneServerBlade,
  AnxIconVerlautbarungWichtigeNewsPressemitteilung,
  AnxIconVerpflegungMittagspauseEssen,
  AnxIconVerschluesselung,
  AnxIconVideo,
  AnxIconVierenBugs,
  AnxIconVirtualisierung,
  AnxIconVollbildVerschieben,
  AnxIconVr,
  AnxIconWachstumUmsatz,
  AnxIconWarningSmall,
  AnxIconWarning,
  AnxIconWebdesign,
  AnxIconWebentwicklung,
  AnxIconWeiterbildung,
  AnxIconWeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc,
  AnxIconWhiteLabel,
  AnxIconWidgets,
  AnxIconWindows,
  AnxIconWlan,
  AnxIconX,
  AnxIconZeitungMedienNews,
  AnxIconZertifikat,
  AnxIconZielMarkierung
} from "./icons";

export const AnxIconsNames = [
  "AnxIcon24h",
  "AnxIcon3d",
  "AnxIconLKWTransport",
  "AnxIconAiKuenstlicheintelligenz",
  "AnxIconAlexa",
  "AnxIconAnderesWeiteresTeil",
  "AnxIconAndroid",
  "AnxIconAnexiaStamp",
  "AnxIconAnexia",
  "AnxIconApp",
  "AnxIconApple",
  "AnxIconArbeitBuero",
  "AnxIconArrowGreenBottom",
  "AnxIconArrowRedBottom",
  "AnxIconAtSign",
  "AnxIconAuszeichnung",
  "AnxIconBarcode",
  "AnxIconBildFoto",
  "AnxIconBlockchain",
  "AnxIconCardboardVrBrilleSmartphone",
  "AnxIconCardboardVrBrille",
  "AnxIconCheckGreen",
  "AnxIconCheckWhite",
  "AnxIconCheck",
  "AnxIconCloudStorage",
  "AnxIconCloud",
  "AnxIconCloudservicesHosting",
  "AnxIconConnections",
  "AnxIconController",
  "AnxIconCopy",
  "AnxIconDashboardEchtzeitMonitor",
  "AnxIconDatenbank",
  "AnxIconDevices",
  "AnxIconDns",
  "AnxIconDokument",
  "AnxIconDollar",
  "AnxIconDownload",
  "AnxIconDsl",
  "AnxIconESim",
  "AnxIconEingabe",
  "AnxIconEins",
  "AnxIconEinstellungenVerwaltung",
  "AnxIconError",
  "AnxIconEuro",
  "AnxIconExperimentierfreudig",
  "AnxIconFabrik",
  "AnxIconFirmenautoAuto",
  "AnxIconFlexibilitaet",
  "AnxIconFlexibleArbeitszeitenTiming",
  "AnxIconFolder",
  "AnxIconForschungEntwicklung",
  "AnxIconFotoapparat",
  "AnxIconFramework",
  "AnxIconGabelstapler",
  "AnxIconGefahrenWarnung",
  "AnxIconGenericautomation",
  "AnxIconHerz",
  "AnxIconHomeoffice",
  "AnxIconIdee",
  "AnxIconInformation",
  "AnxIconInstallation",
  "AnxIconInterdisziplinaer",
  "AnxIconIp",
  "AnxIconKalender",
  "AnxIconKontaktTelefonTelekommunikation",
  "AnxIconKonzept",
  "AnxIconKunde",
  "AnxIconKunden",
  "AnxIconLaden",
  "AnxIconLastverteilung",
  "AnxIconLike",
  "AnxIconLoeschen",
  "AnxIconMailKontakt",
  "AnxIconMassgeschneiderteIndividuelleLoesungen",
  "AnxIconMbaas",
  "AnxIconMicrocontroller",
  "AnxIconMitarbeiterevents",
  "AnxIconMobileEntwicklung",
  "AnxIconMonitoring",
  "AnxIconMusik",
  "AnxIconNetzwerk",
  "AnxIconOeffentlicherNahverkehr",
  "AnxIconOffline",
  "AnxIconOnlineshopWarenkorb",
  "AnxIconPaket",
  "AnxIconParkplatz",
  "AnxIconPartyProjektabschluss",
  "AnxIconPdf",
  "AnxIconPfeilLinksKlein",
  "AnxIconPfeilLinks",
  "AnxIconPfeilOben",
  "AnxIconPfeilRechtsKlein",
  "AnxIconPfeilRechts",
  "AnxIconPfeilRunter",
  "AnxIconPflichtenheft",
  "AnxIconPlatform",
  "AnxIconPraesentation",
  "AnxIconProjektablauf",
  "AnxIconProjektmanagementCheckliste",
  "AnxIconRedundant",
  "AnxIconSatellit",
  "AnxIconSchluessel",
  "AnxIconScrum",
  "AnxIconSeoSemCrawler",
  "AnxIconServerVeerbunden",
  "AnxIconServiceprovider",
  "AnxIconSharing",
  "AnxIconShop",
  "AnxIconSicherheitFirewall",
  "AnxIconSignal",
  "AnxIconSkalierbar",
  "AnxIconSmartTv",
  "AnxIconSmartWatch",
  "AnxIconSmarthome",
  "AnxIconSoftwareentwicklungCode",
  "AnxIconSpieleUndSpass",
  "AnxIconSprechblasen",
  "AnxIconStandortUnternehmenssitz",
  "AnxIconStartUp",
  "AnxIconStatistikAnalysen",
  "AnxIconStern",
  "AnxIconStorageBackup",
  "AnxIconStromEnergie",
  "AnxIconSuchen",
  "AnxIconSupportMitarbeiter",
  "AnxIconTasse",
  "AnxIconTeam",
  "AnxIconTechnischerSupport",
  "AnxIconTextdokument",
  "AnxIconTextdokumentFragezeichen",
  "AnxIconTextdokumentRufzeichen",
  "AnxIconUpload",
  "AnxIconUserProfil",
  "AnxIconVerbundeneServerBlade",
  "AnxIconVerlautbarungWichtigeNewsPressemitteilung",
  "AnxIconVerpflegungMittagspauseEssen",
  "AnxIconVerschluesselung",
  "AnxIconVideo",
  "AnxIconVierenBugs",
  "AnxIconVirtualisierung",
  "AnxIconVollbildVerschieben",
  "AnxIconVr",
  "AnxIconWachstumUmsatz",
  "AnxIconWarningSmall",
  "AnxIconWarning",
  "AnxIconWebdesign",
  "AnxIconWebentwicklung",
  "AnxIconWeiterbildung",
  "AnxIconWeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc",
  "AnxIconWhiteLabel",
  "AnxIconWidgets",
  "AnxIconWindows",
  "AnxIconWlan",
  "AnxIconX",
  "AnxIconZeitungMedienNews",
  "AnxIconZertifikat",
  "AnxIconZielMarkierung"
];

export const AnxIconsPlugin = {
  install: function() {
    Vue.component("AnxIcon24h", AnxIcon24h);
    Vue.component("AnxIcon3d", AnxIcon3d);
    Vue.component("AnxIconLKWTransport", AnxIconLKWTransport);
    Vue.component("AnxIconAiKuenstlicheintelligenz", AnxIconAiKuenstlicheintelligenz);
    Vue.component("AnxIconAlexa", AnxIconAlexa);
    Vue.component("AnxIconAnderesWeiteresTeil", AnxIconAnderesWeiteresTeil);
    Vue.component("AnxIconAndroid", AnxIconAndroid);
    Vue.component("AnxIconAnexiaStamp", AnxIconAnexiaStamp);
    Vue.component("AnxIconAnexia", AnxIconAnexia);
    Vue.component("AnxIconApp", AnxIconApp);
    Vue.component("AnxIconApple", AnxIconApple);
    Vue.component("AnxIconArbeitBuero", AnxIconArbeitBuero);
    Vue.component("AnxIconArrowGreenBottom", AnxIconArrowGreenBottom);
    Vue.component("AnxIconArrowRedBottom", AnxIconArrowRedBottom);
    Vue.component("AnxIconAtSign", AnxIconAtSign);
    Vue.component("AnxIconAuszeichnung", AnxIconAuszeichnung);
    Vue.component("AnxIconBarcode", AnxIconBarcode);
    Vue.component("AnxIconBildFoto", AnxIconBildFoto);
    Vue.component("AnxIconBlockchain", AnxIconBlockchain);
    Vue.component("AnxIconCardboardVrBrilleSmartphone", AnxIconCardboardVrBrilleSmartphone);
    Vue.component("AnxIconCardboardVrBrille", AnxIconCardboardVrBrille);
    Vue.component("AnxIconCheckGreen", AnxIconCheckGreen);
    Vue.component("AnxIconCheckWhite", AnxIconCheckWhite);
    Vue.component("AnxIconCheck", AnxIconCheck);
    Vue.component("AnxIconCloudStorage", AnxIconCloudStorage);
    Vue.component("AnxIconCloud", AnxIconCloud);
    Vue.component("AnxIconCloudservicesHosting", AnxIconCloudservicesHosting);
    Vue.component("AnxIconConnections", AnxIconConnections);
    Vue.component("AnxIconController", AnxIconController);
    Vue.component("AnxIconCopy", AnxIconCopy);
    Vue.component("AnxIconDashboardEchtzeitMonitor", AnxIconDashboardEchtzeitMonitor);
    Vue.component("AnxIconDatenbank", AnxIconDatenbank);
    Vue.component("AnxIconDevices", AnxIconDevices);
    Vue.component("AnxIconDns", AnxIconDns);
    Vue.component("AnxIconDokument", AnxIconDokument);
    Vue.component("AnxIconDollar", AnxIconDollar);
    Vue.component("AnxIconDownload", AnxIconDownload);
    Vue.component("AnxIconDsl", AnxIconDsl);
    Vue.component("AnxIconESim", AnxIconESim);
    Vue.component("AnxIconEingabe", AnxIconEingabe);
    Vue.component("AnxIconEins", AnxIconEins);
    Vue.component("AnxIconEinstellungenVerwaltung", AnxIconEinstellungenVerwaltung);
    Vue.component("AnxIconError", AnxIconError);
    Vue.component("AnxIconEuro", AnxIconEuro);
    Vue.component("AnxIconExperimentierfreudig", AnxIconExperimentierfreudig);
    Vue.component("AnxIconFabrik", AnxIconFabrik);
    Vue.component("AnxIconFirmenautoAuto", AnxIconFirmenautoAuto);
    Vue.component("AnxIconFlexibilitaet", AnxIconFlexibilitaet);
    Vue.component("AnxIconFlexibleArbeitszeitenTiming", AnxIconFlexibleArbeitszeitenTiming);
    Vue.component("AnxIconFolder", AnxIconFolder);
    Vue.component("AnxIconForschungEntwicklung", AnxIconForschungEntwicklung);
    Vue.component("AnxIconFotoapparat", AnxIconFotoapparat);
    Vue.component("AnxIconFramework", AnxIconFramework);
    Vue.component("AnxIconGabelstapler", AnxIconGabelstapler);
    Vue.component("AnxIconGefahrenWarnung", AnxIconGefahrenWarnung);
    Vue.component("AnxIconGenericautomation", AnxIconGenericautomation);
    Vue.component("AnxIconHerz", AnxIconHerz);
    Vue.component("AnxIconHomeoffice", AnxIconHomeoffice);
    Vue.component("AnxIconIdee", AnxIconIdee);
    Vue.component("AnxIconInformation", AnxIconInformation);
    Vue.component("AnxIconInstallation", AnxIconInstallation);
    Vue.component("AnxIconInterdisziplinaer", AnxIconInterdisziplinaer);
    Vue.component("AnxIconIp", AnxIconIp);
    Vue.component("AnxIconKalender", AnxIconKalender);
    Vue.component("AnxIconKontaktTelefonTelekommunikation", AnxIconKontaktTelefonTelekommunikation);
    Vue.component("AnxIconKonzept", AnxIconKonzept);
    Vue.component("AnxIconKunde", AnxIconKunde);
    Vue.component("AnxIconKunden", AnxIconKunden);
    Vue.component("AnxIconLaden", AnxIconLaden);
    Vue.component("AnxIconLastverteilung", AnxIconLastverteilung);
    Vue.component("AnxIconLike", AnxIconLike);
    Vue.component("AnxIconLoeschen", AnxIconLoeschen);
    Vue.component("AnxIconMailKontakt", AnxIconMailKontakt);
    Vue.component("AnxIconMassgeschneiderteIndividuelleLoesungen", AnxIconMassgeschneiderteIndividuelleLoesungen);
    Vue.component("AnxIconMbaas", AnxIconMbaas);
    Vue.component("AnxIconMicrocontroller", AnxIconMicrocontroller);
    Vue.component("AnxIconMitarbeiterevents", AnxIconMitarbeiterevents);
    Vue.component("AnxIconMobileEntwicklung", AnxIconMobileEntwicklung);
    Vue.component("AnxIconMonitoring", AnxIconMonitoring);
    Vue.component("AnxIconMusik", AnxIconMusik);
    Vue.component("AnxIconNetzwerk", AnxIconNetzwerk);
    Vue.component("AnxIconOeffentlicherNahverkehr", AnxIconOeffentlicherNahverkehr);
    Vue.component("AnxIconOffline", AnxIconOffline);
    Vue.component("AnxIconOnlineshopWarenkorb", AnxIconOnlineshopWarenkorb);
    Vue.component("AnxIconPaket", AnxIconPaket);
    Vue.component("AnxIconParkplatz", AnxIconParkplatz);
    Vue.component("AnxIconPartyProjektabschluss", AnxIconPartyProjektabschluss);
    Vue.component("AnxIconPdf", AnxIconPdf);
    Vue.component("AnxIconPfeilLinksKlein", AnxIconPfeilLinksKlein);
    Vue.component("AnxIconPfeilLinks", AnxIconPfeilLinks);
    Vue.component("AnxIconPfeilOben", AnxIconPfeilOben);
    Vue.component("AnxIconPfeilRechtsKlein", AnxIconPfeilRechtsKlein);
    Vue.component("AnxIconPfeilRechts", AnxIconPfeilRechts);
    Vue.component("AnxIconPfeilRunter", AnxIconPfeilRunter);
    Vue.component("AnxIconPflichtenheft", AnxIconPflichtenheft);
    Vue.component("AnxIconPlatform", AnxIconPlatform);
    Vue.component("AnxIconPraesentation", AnxIconPraesentation);
    Vue.component("AnxIconProjektablauf", AnxIconProjektablauf);
    Vue.component("AnxIconProjektmanagementCheckliste", AnxIconProjektmanagementCheckliste);
    Vue.component("AnxIconRedundant", AnxIconRedundant);
    Vue.component("AnxIconSatellit", AnxIconSatellit);
    Vue.component("AnxIconSchluessel", AnxIconSchluessel);
    Vue.component("AnxIconScrum", AnxIconScrum);
    Vue.component("AnxIconSeoSemCrawler", AnxIconSeoSemCrawler);
    Vue.component("AnxIconServerVeerbunden", AnxIconServerVeerbunden);
    Vue.component("AnxIconServiceprovider", AnxIconServiceprovider);
    Vue.component("AnxIconSharing", AnxIconSharing);
    Vue.component("AnxIconShop", AnxIconShop);
    Vue.component("AnxIconSicherheitFirewall", AnxIconSicherheitFirewall);
    Vue.component("AnxIconSignal", AnxIconSignal);
    Vue.component("AnxIconSkalierbar", AnxIconSkalierbar);
    Vue.component("AnxIconSmartTv", AnxIconSmartTv);
    Vue.component("AnxIconSmartWatch", AnxIconSmartWatch);
    Vue.component("AnxIconSmarthome", AnxIconSmarthome);
    Vue.component("AnxIconSoftwareentwicklungCode", AnxIconSoftwareentwicklungCode);
    Vue.component("AnxIconSpieleUndSpass", AnxIconSpieleUndSpass);
    Vue.component("AnxIconSprechblasen", AnxIconSprechblasen);
    Vue.component("AnxIconStandortUnternehmenssitz", AnxIconStandortUnternehmenssitz);
    Vue.component("AnxIconStartUp", AnxIconStartUp);
    Vue.component("AnxIconStatistikAnalysen", AnxIconStatistikAnalysen);
    Vue.component("AnxIconStern", AnxIconStern);
    Vue.component("AnxIconStorageBackup", AnxIconStorageBackup);
    Vue.component("AnxIconStromEnergie", AnxIconStromEnergie);
    Vue.component("AnxIconSuchen", AnxIconSuchen);
    Vue.component("AnxIconSupportMitarbeiter", AnxIconSupportMitarbeiter);
    Vue.component("AnxIconTasse", AnxIconTasse);
    Vue.component("AnxIconTeam", AnxIconTeam);
    Vue.component("AnxIconTechnischerSupport", AnxIconTechnischerSupport);
    Vue.component("AnxIconTextdokument", AnxIconTextdokument);
    Vue.component("AnxIconTextdokumentFragezeichen", AnxIconTextdokumentFragezeichen);
    Vue.component("AnxIconTextdokumentRufzeichen", AnxIconTextdokumentRufzeichen);
    Vue.component("AnxIconUpload", AnxIconUpload);
    Vue.component("AnxIconUserProfil", AnxIconUserProfil);
    Vue.component("AnxIconVerbundeneServerBlade", AnxIconVerbundeneServerBlade);
    Vue.component("AnxIconVerlautbarungWichtigeNewsPressemitteilung", AnxIconVerlautbarungWichtigeNewsPressemitteilung);
    Vue.component("AnxIconVerpflegungMittagspauseEssen", AnxIconVerpflegungMittagspauseEssen);
    Vue.component("AnxIconVerschluesselung", AnxIconVerschluesselung);
    Vue.component("AnxIconVideo", AnxIconVideo);
    Vue.component("AnxIconVierenBugs", AnxIconVierenBugs);
    Vue.component("AnxIconVirtualisierung", AnxIconVirtualisierung);
    Vue.component("AnxIconVollbildVerschieben", AnxIconVollbildVerschieben);
    Vue.component("AnxIconVr", AnxIconVr);
    Vue.component("AnxIconWachstumUmsatz", AnxIconWachstumUmsatz);
    Vue.component("AnxIconWarningSmall", AnxIconWarningSmall);
    Vue.component("AnxIconWarning", AnxIconWarning);
    Vue.component("AnxIconWebdesign", AnxIconWebdesign);
    Vue.component("AnxIconWebentwicklung", AnxIconWebentwicklung);
    Vue.component("AnxIconWeiterbildung", AnxIconWeiterbildung);
    Vue.component("AnxIconWeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc", AnxIconWeltweiteInfrastrukturWeltweiteVernetzungGlobalWwc);
    Vue.component("AnxIconWhiteLabel", AnxIconWhiteLabel);
    Vue.component("AnxIconWidgets", AnxIconWidgets);
    Vue.component("AnxIconWindows", AnxIconWindows);
    Vue.component("AnxIconWlan", AnxIconWlan);
    Vue.component("AnxIconX", AnxIconX);
    Vue.component("AnxIconZeitungMedienNews", AnxIconZeitungMedienNews);
    Vue.component("AnxIconZertifikat", AnxIconZertifikat);
    Vue.component("AnxIconZielMarkierung", AnxIconZielMarkierung)
}
};

// --- END AUTO-GENERATED FILE ---
